import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { Card, Skeleton, CardPanel, WidgetEmptyErrorPlaceholder } from "@ann/web-components";
import { ModelSelectorContent } from "./components/ModelSelectorContent";
import { EmptyStateWrapper } from "./ModelSelector.styled";
import ScrollableCardContent from "../ScrollableCardContent";
import { useModelSelector } from "../../../../hooks/useModelSelector";

const ModelSelector = observer(({ contactId, onSelectedVehicleChange }) => {
  const hookData = useModelSelector(contactId);
  const { loading, vehicles, error, handleRetry, selectedVehicle } = hookData;

  // Notificar cambios en selectedVehicle al componente padre
  useEffect(() => {
    if (onSelectedVehicleChange && selectedVehicle) {
      onSelectedVehicleChange(selectedVehicle);
    }
  }, [selectedVehicle, onSelectedVehicleChange]);

  
  if (loading ) {
    return (
      <Skeleton height="428px" width="100%" />
    );
  }

  if (error) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <WidgetEmptyErrorPlaceholder
              buttonText="Retry"
              icon="error"
              message="We couldn't load the vehicles. Please try again."
              onClick={handleRetry}
              showButton
              title="Something went wrong"
            />
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  // Show empty state
  if (!loading && vehicles.length === 0) {
    return (
      <Card size='large'>
        <CardPanel isExpandable={false} openDefault={true}>
          <CardPanel.Content>
            <EmptyStateWrapper>
              <WidgetEmptyErrorPlaceholder
                icon="directionsCar"
                message="Vehicle information will appear here as soon as it s available."
                showButton={false}
                title="No vehicles to display"
              />
            </EmptyStateWrapper>
          </CardPanel.Content>
        </CardPanel>
      </Card>
    );
  }

  return (
    <Card size='large'>
      <ScrollableCardContent>
        <ModelSelectorContent hookData={hookData} />
      </ScrollableCardContent>
    </Card>
  );
});

export default ModelSelector; 